(() => {
  const colors = { Zwart: '#222222', Rood: '#a52c32', Groen: '#205d44', Goud: '#92732a' };
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const file = root.querySelector('[data-kb-input]');
    const image = root.querySelector('[data-kb-preview]');
    const message = root.querySelector('[data-kb-message]');
    const text = root.querySelector('[data-kb-text]');
    const font = root.querySelector('[data-kb-font]');
    const color = root.querySelector('[data-kb-color]');
    const error = root.querySelector('[data-kb-error]');
    const remove = root.querySelector('[data-kb-remove]');
    const bgTools = root.querySelector('[data-kb-bg-tools]');
    const bgRemove = root.querySelector('[data-kb-bg-remove]');
    const bgRestore = root.querySelector('[data-kb-bg-restore]');
    const bgStatus = root.querySelector('[data-kb-bg-status]');
    const originalInput = root.querySelector('[data-kb-original]');
    const bgProperty = root.querySelector('[data-kb-bg-property]');
    let originalFile = null, applyingEdit = false, bgBusy = false;
    let url, version = 0, pending = false, pdfController = null;
    function setInput(input, selectedFile) {
      const transfer = new DataTransfer();
      if (selectedFile) transfer.items.add(selectedFile);
      input.files = transfer.files;
    }
    function showError(value) { error.textContent = value; error.hidden = !value; }
    function update() {
      text.textContent = message.value;
      text.style.fontFamily = font.value;
      text.style.color = colors[color.value];
      text.style.fontSize = (image.hidden ? (message.value.length > 30 ? 11 : 15) : (message.value.length > 30 ? 8 : 11)) + 'px';
      root.classList.toggle('kb-has-photo', !image.hidden);
      root.querySelector('[data-kb-placeholder]').hidden = !image.hidden || !!message.value.trim();
      message.setCustomValidity('');
      root.dispatchEvent(new CustomEvent('kb:design-change', {bubbles:true}));
    }
    function reset(keepFile = false) {
      if (pdfController) { pdfController.abort(); pdfController = null; }
      version++; pending = false;
      image.onload = image.onerror = null;
      if (url) URL.revokeObjectURL(url);
      url = null; if (!keepFile) file.value = ''; image.hidden = true; image.removeAttribute('src');
      root.querySelector('[data-kb-filename]').textContent = 'Nog geen bestand gekozen.';
      remove.hidden = true; root.querySelector('[data-kb-placeholder]').textContent = 'Jouw ontwerp'; update();
    }
    file.addEventListener('change', () => {
      const chosen = file.files[0]; reset(true); showError('');
      bgBusy = false;
      if (!applyingEdit) {
        originalFile = chosen || null; originalInput.value = ''; originalInput.disabled = true;
        file.name = 'properties[Foto of logo]'; originalInput.name = 'properties[Origineel bestand]';
        bgProperty.value = 'Origineel'; bgRestore.hidden = true; bgStatus.textContent = '';
      }
      bgTools.hidden = true; bgRemove.disabled = true;
      if (!chosen) return;
      const extension = chosen.name.split('.').pop().trim().toLowerCase();
      const mime = (chosen.type || '').split(';')[0].trim().toLowerCase();
      const allowed = {png:['image/png'],jpg:['image/jpeg'],jpeg:['image/jpeg'],pdf:['application/pdf','application/x-pdf','application/acrobat','application/vnd.pdf','application/octet-stream'],svg:['image/svg+xml']};
      if (!allowed[extension] || (mime && !allowed[extension].includes(mime))) {
        reset(); showError('Kies een PDF-, SVG-, PNG- of JPG-bestand. WebP wordt niet geaccepteerd als drukbestand.'); return;
      }
      if (!chosen.size || chosen.size > 20 * 1024 * 1024) { reset(); showError('Kies een niet-leeg bestand van maximaal 20 MB.'); return; }
      if (extension === 'pdf') {
        const current = version, controller = new AbortController();
        pdfController = controller; pending = true; remove.hidden = false;
        root.querySelector('[data-kb-filename]').textContent = chosen.name + ' — PDF-voorbeeld laden…';
        root.querySelector('[data-kb-placeholder]').textContent = 'PDF laden…';
        const timer = setTimeout(() => { controller.abort(); if (current === version) pdfFallback(); }, 20000);
        (async () => {
          try {
            const config = JSON.parse(root.querySelector('[data-kb-pdf-config]').textContent);
            const result = await window.KBPdfPreview.render(chosen, config, controller.signal);
            if (current !== version) return;
            image.onload = () => {
              if (current !== version) return;
              pending = false; image.hidden = false; remove.hidden = false;
              bgTools.hidden = false; bgRemove.disabled = bgProperty.value !== 'Origineel';
              root.querySelector('[data-kb-filename]').textContent = chosen.name + ' — pagina 1' + (result.pages > 1 ? ' van ' + result.pages : '') + ' in het voorbeeld. Het originele PDF-bestand wordt meegestuurd.';
              showError(''); update();
            };
            image.onerror = () => { if (current === version) pdfFallback(); };
            image.src = result.src;
          } catch (_) { if (current === version) pdfFallback(); }
          finally { clearTimeout(timer); if (pdfController === controller) pdfController = null; }
        })();
        function pdfFallback() {
          pending = false; image.hidden = true; image.removeAttribute('src');
          bgTools.hidden = true;
          root.querySelector('[data-kb-placeholder]').textContent = 'PDF geselecteerd';
          root.querySelector('[data-kb-filename]').textContent = chosen.name + ' — origineel geselecteerd voor je bestelling.';
          showError('Het PDF-voorbeeld kon niet worden gemaakt. Je kunt het originele bestand wel meesturen. Gebruik een PDF zonder wachtwoord of kies een PNG/JPG voor het voorbeeld.');
          update();
        }
        update(); return;
      }
      if (extension === 'svg') {
        remove.hidden = false;
        root.querySelector('[data-kb-filename]').textContent = chosen.name + ' — geselecteerd. Wordt bij je bestelling meegestuurd; niet zichtbaar op de kerstbal.';
        root.querySelector('[data-kb-placeholder]').textContent = 'Drukbestand geselecteerd';
        update(); return;
      }
      const current = version; pending = true;
      let previewTrimmed = false;
      url = URL.createObjectURL(chosen);
      image.onload = () => {
        if (current !== version) return;
        // Trim transparent padding for the preview only; retain the original print file.
        if (!previewTrimmed) {
          previewTrimmed = true;
          try {
            const scale = Math.min(1, 2048 / Math.max(image.naturalWidth, image.naturalHeight));
            const canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
            canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
            const ctx = canvas.getContext('2d', {willReadFrequently:true});
            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
            const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
            let left = canvas.width, top = canvas.height, right = -1, bottom = -1;
            for (let y = 0; y < canvas.height; y++) for (let x = 0; x < canvas.width; x++) {
              if (data[(y * canvas.width + x) * 4 + 3] > 8) {
                left = Math.min(left,x); right = Math.max(right,x);
                top = Math.min(top,y); bottom = Math.max(bottom,y);
              }
            }
            if (right >= left && (left || top || right < canvas.width-1 || bottom < canvas.height-1)) {
              const cropped = document.createElement('canvas');
              cropped.width = right-left+1; cropped.height = bottom-top+1;
              cropped.getContext('2d').drawImage(canvas,left,top,cropped.width,cropped.height,0,0,cropped.width,cropped.height);
              image.src = cropped.toDataURL('image/png'); return;
            }
          } catch (_) { /* Keep the unmodified preview if canvas is unavailable. */ }
        }
        pending = false; image.hidden = false; remove.hidden = false;
        bgTools.hidden = false; bgRemove.disabled = bgProperty.value !== 'Origineel';
        root.querySelector('[data-kb-filename]').textContent = chosen.name;
        showError(''); update();
      };
      image.onerror = () => {
        if (current !== version) return;
        if (bgProperty.value !== 'Origineel' && originalFile) {
          try {
            setInput(file, originalFile); file.dispatchEvent(new Event('change', {bubbles:true}));
            bgStatus.textContent = 'Het bewerkte bestand kon niet worden getoond. Het origineel is hersteld.';
            return;
          } catch (_) { /* Fall through to a clear file error. */ }
        }
        reset(); originalInput.value = ''; originalInput.disabled = true;
        bgProperty.value = 'Origineel'; bgTools.hidden = true;
        showError('Deze afbeelding is niet leesbaar. Kies een andere foto.');
      };
      image.src = url;
    });
    bgRemove.addEventListener('click', async () => {
      if (pending || bgBusy || !originalFile || image.hidden) return;
      const current = version, saved = originalFile;
      bgBusy = true; bgRemove.disabled = true; bgStatus.textContent = 'Witte achtergrond verwijderen…';
      try {
        // Let the busy message render before processing the local image.
        await new Promise(resolve => setTimeout(resolve, 0));
        const scale = Math.min(1, 2048 / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        const context = canvas.getContext('2d', {willReadFrequently:true});
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
        const result = KBRemoveWhite(pixels.data, canvas.width, canvas.height);
        if (!result.removed) throw new Error('Geen witte achtergrond langs de buitenrand gevonden. Het origineel blijft staan.');
        if (!result.remaining) throw new Error('Er bleef geen zichtbaar ontwerp over. Het origineel blijft staan.');
        context.putImageData(pixels, 0, 0);
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
        if (current !== version) return;
        if (!blob || blob.size > 20*1024*1024) throw new Error('Het resultaat kon niet worden opgeslagen. Het origineel blijft staan.');
        const edited = new File([blob], saved.name.replace(/\.[^.]+$/, '') + '-zonder-wit.png', {type:'image/png'});
        setInput(file, edited);
        setInput(originalInput, saved); originalInput.disabled = false;
        file.name = 'properties[Voorbeeld zonder achtergrond]'; originalInput.name = 'properties[Foto of logo]';
        bgProperty.value = 'Alleen voorbeeld vrijstaand; origineel gebruiken voor drukproef';
        applyingEdit = true;
        try { file.dispatchEvent(new Event('change', {bubbles:true})); } finally { applyingEdit = false; }
        bgRestore.hidden = false;
        bgStatus.textContent = 'Dit is alleen een voorbeeld. Wij gebruiken je originele bestand voor de drukproef en maken het zo nodig handmatig vrijstaand.';
      } catch (error) {
        if (current === version) {
          // Restore the selected original if assigning a processed file failed halfway.
          try { setInput(file, saved); } catch (_) { /* original input normally remains unchanged */ }
          originalInput.value = ''; originalInput.disabled = true; file.name = 'properties[Foto of logo]'; originalInput.name = 'properties[Origineel bestand]'; bgProperty.value = 'Origineel';
          bgStatus.textContent = error.message || 'Bewerken lukt niet in deze browser. Gebruik het origineel of een transparante PNG.';
        }
      } finally {
        if (current === version) { bgBusy = false; bgRemove.disabled = bgProperty.value !== 'Origineel'; }
      }
    });
    bgRestore.addEventListener('click', () => {
      if (!originalFile) return;
      try {
        setInput(file, originalFile);
        file.dispatchEvent(new Event('change', {bubbles:true}));
        bgStatus.textContent = 'Het originele bestand is hersteld.';
      } catch (_) { showError('Kies je originele bestand opnieuw via het uploadveld.'); }
    });
    remove.addEventListener('click', () => {
      reset(); originalFile = null; originalInput.value = ''; originalInput.disabled = true;
      bgProperty.value = 'Origineel'; bgTools.hidden = true; bgBusy = false; showError('');
    });
    [message, font, color].forEach(control => control.addEventListener('input', () => { update(); showError(''); }));
    root.closest('form').addEventListener('submit', event => {
      if (pending || bgBusy) { event.preventDefault(); showError('Wacht even tot je foto is geladen of bewerkt.'); return; }
      if (!file.files.length && !message.value.trim()) {
        event.preventDefault(); showError('Voeg een foto of tekst toe om je kerstbal te personaliseren.'); message.focus();
      }
    });
    update();
  }
  function boot() { document.querySelectorAll('[data-kb-personalizer]').forEach(init); }
  boot(); document.addEventListener('shopify:section:load', boot);
  document.addEventListener('change', event => {
    if (!event.target.matches('select[name="id"][data-kb-variants]')) return;
    const select = event.target, form = select.closest('form');
    const variants = JSON.parse(form.querySelector('[data-kb-variant-json]').textContent);
    const variant = variants.find(v => String(v.id) === select.value);
    if (!variant) return;
    const price = document.getElementById(select.dataset.priceTarget);
    if (price) price.textContent = variant.price;
    const unit = form.querySelector('[data-kb-unit-price]');
    if (unit && variant.unit_price) unit.textContent = variant.unit_price + ' per kerstbal · ' + (unit.dataset.taxLabel || '');
    const button = form.querySelector('[name="add"]');
    button.disabled = !variant.available; button.textContent = variant.available ? button.dataset.label : 'Uitverkocht';
  });
})();
